export default __webpack_public_path__ + "static/media/logo_dikotech.7a8d3f67.jpeg";